module.exports = __webpack_public_path__ + "static/media/26UNRWA4.b74f4c25.jpg";